import axios from 'axios';
import { logout } from './datric.api';
import queryString from 'query-string';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3050';

axios.interceptors.response.use(
	response => response,
	error => {
		if (
			401 === error?.response?.status &&
			!error.request?.responseURL?.includes('/me') &&
			!error.request?.responseURL?.includes('auth/login')
		) {
			logout();
			return Promise.reject(error);
		}
		if (
			error.response &&
			error.response?.data &&
			error.response.data?.message &&
			Array.isArray(error.response.data.message)
		) {
			return Promise.reject(error.response.data.message.join(', '));
		}
		if (error.response && error.response?.data && error.response.data?.message) {
			return Promise.reject(error.response.data.message);
		}
		return Promise.reject(error);
	}
);

export default class DatricRequests {
	get = async (path: string, params?: any, headers?: any): Promise<any> => {
		try {
			const query = queryString.stringify(params || {}, { arrayFormat: 'bracket' });
			const url = query ? `${API_URL}/${path}?${query}` : `${API_URL}/${path}`;
			const result = await axios.get(url, headers);
			return result.data;
		} catch (e: any) {
			if (e.response && e.response.data && e.response.data.message) {
				throw e.response.data.message;
			}
			throw e;
		}
	};

	post = async (path: string, data?: any, headers?: any): Promise<any> => {
		try {
			const result = await axios.post(`${API_URL}/${path}`, data, headers);
			return result.data;
		} catch (e: any) {
			if (e.response && e.response.data && e.response.data.message) {
				throw e.response.data.message;
			}
			throw e;
		}
	};

	put = async (path: string, data?: any): Promise<any> => {
		try {
			const result = await axios.put(`${API_URL}/${path}`, data);
			return result.data;
		} catch (e: any) {
			if (e.response && e.response.data && e.response.data.message) {
				throw e.response.data.message;
			}
			throw e;
		}
	};

	patch = async (path: string, data?: any): Promise<any> => {
		try {
			const result = await axios.patch(`${API_URL}/${path}`, data);
			return result.data;
		} catch (e: any) {
			if (e.response && e.response.data && e.response.data.message) {
				throw e.response.data.message;
			}
			throw e;
		}
	};

	delete = async (path: string): Promise<any> => {
		try {
			const result = await axios.delete(`${API_URL}/${path}`);
			return result.data;
		} catch (e: any) {
			if (e.response && e.response.data && e.response.data.message) {
				throw e.response.data.message;
			}
			throw e;
		}
	};
}
